import * as React from "react";

export function ShieldOrnaments({ isActive }: { isActive: boolean }) {
    const ornamentSize = isActive ? 12 : 10;
    const topOffset = isActive ? 8 : 6;
    const bottomOffset = isActive ? 6 : 5;
    const ornamentIdSuffix = isActive ? "active" : "inactive";
    const fillGradientId = `shieldOrnamentMetal_${ornamentIdSuffix}`;
    const glowGradientId = `shieldOrnamentGlow_${ornamentIdSuffix}`;

    function RenderOrnament({
        flipForBottom = false,
    }: {
        flipForBottom?: boolean;
    }) {
        const instanceSuffix = flipForBottom ? "bottom" : "top";
        const instanceFillGradientId = `${fillGradientId}_${instanceSuffix}`;
        const instanceGlowGradientId = `${glowGradientId}_${instanceSuffix}`;

        return (
            <svg
                viewBox="-16 -16 32 32"
                width={ornamentSize}
                height={ornamentSize}
                aria-hidden="true"
                focusable="false"
            >
                <defs>
                    <linearGradient
                        id={instanceFillGradientId}
                        x1="0"
                        y1="-16"
                        x2="0"
                        y2="16"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0%" stopColor="#fff0bf" />
                        <stop offset="20%" stopColor="#e0ba66" />
                        <stop offset="58%" stopColor="#95661d" />
                        <stop offset="100%" stopColor="#4f340b" />
                    </linearGradient>
                    <linearGradient
                        id={instanceGlowGradientId}
                        x1="0"
                        y1="-16"
                        x2="0"
                        y2="6"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0%" stopColor="#fff8dc" stopOpacity="0.96" />
                        <stop offset="42%" stopColor="#fff1bf" stopOpacity="0.42" />
                        <stop offset="100%" stopColor="#fff1bf" stopOpacity="0" />
                    </linearGradient>
                </defs>
                <g
                    transform={flipForBottom ? "scale(1 -1)" : undefined}
                    filter="drop-shadow(0 0 2px rgba(184, 134, 11, 0.34)) drop-shadow(0 -1px 3px rgba(255, 232, 164, 0.28))"
                >
                    <g
                        fill={`url(#${instanceFillGradientId})`}
                        stroke="#7a5920"
                        strokeWidth="0.72"
                        strokeLinejoin="round"
                        opacity="0.9"
                    >
                        <path d="M 0 -13 L -3.8 -9 L 0 -4.2 L 3.8 -9 Z" />
                        <path d="M -10.8 -3.2 C -8.8 -6.6 -5.8 -6.8 -3.7 -4.8 C -5.5 -3.8 -6.3 -2.4 -6.1 -0.2 C -7.7 -0.9 -9 -1.7 -10.8 -3.2 Z" />
                        <path d="M 10.8 -3.2 C 8.8 -6.6 5.8 -6.8 3.7 -4.8 C 5.5 -3.8 6.3 -2.4 6.1 -0.2 C 7.7 -0.9 9 -1.7 10.8 -3.2 Z" />
                        <path d="M -3.5 0.2 C -2.1 1.6 -0.9 3.2 0 5.8 C 0.9 3.2 2.1 1.6 3.5 0.2 C 2 0 0.8 -0.4 0 -1.6 C -0.8 -0.4 -2 0 -3.5 0.2 Z" />
                    </g>
                    <g
                        fill="none"
                        stroke={`url(#${instanceGlowGradientId})`}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        opacity="0.9"
                    >
                        <path d="M 0 -12.2 L -2.1 -9.3 L 0 -6.2 L 2.1 -9.3 Z" />
                        <path d="M -8.9 -3.7 C -7.7 -5.2 -5.9 -5.3 -4.5 -4.4" />
                        <path d="M 8.9 -3.7 C 7.7 -5.2 5.9 -5.3 4.5 -4.4" />
                        <path d="M -2.1 0.5 C -1 1.4 -0.3 2.5 0 3.8 C 0.3 2.5 1 1.4 2.1 0.5" />
                    </g>
                </g>
            </svg>
        );
    }

    return (
        <span
            style={{
                position: `absolute`,
                inset: 0,
                zIndex: 4,
                pointerEvents: `none`,
            }}
        >
            <span
                style={{
                    position: `absolute`,
                    top: topOffset,
                    left: `50%`,
                    transform: `translateX(-50%)`,
                    lineHeight: 0,
                }}
            >
                <RenderOrnament />
            </span>
            <span
                style={{
                    position: `absolute`,
                    bottom: bottomOffset,
                    left: `50%`,
                    transform: `translateX(-50%)`,
                    lineHeight: 0,
                }}
            >
                <RenderOrnament flipForBottom />
            </span>
        </span>
    );
}
